module.exports = __webpack_public_path__ + "static/media/descrip6.bb28395b.jpg";